var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00659 10.7926C1.00659 12.3402 2.20322 13.5846 3.67105 13.5846H6.6705C7.94687 13.5846 8.98395 12.4997 8.98395 11.1436C8.98395 9.69169 8.34578 9.16519 7.40445 8.83014L2.60206 7.15489C1.66074 6.81984 1.02256 6.30929 1.02256 4.84146C1.02256 3.50126 2.05959 2.40039 3.33597 2.40039H6.33546C7.80329 2.40039 8.99992 3.64486 8.99992 5.19247",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99536 0.820312V15.1796",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5f900e0210baf6186e571ec159508194.svg";
export { ForwardRef as ReactComponent };